// 当前页面

let currentPage = 1;

class ArticleContent {
  constructor() {
    this.enableContent = document.querySelector('[data-enable-content]')?.dataset.enableContent;
    this.articleContainer = document.querySelector('[data-article-container]');
    this.articleContents = document.querySelectorAll('[data-article-id]');
    this.articleContentsIds = [];
    if (this.enableContent && JSON.parse(this.enableContent)) {
      this.getArticleInfo();
      this.init();
    }
  }
  
  init() {
    this.renderArticleContent();
  }
  
  /**
   * 渲染文章内容
   * @param index
   * @returns {Promise<void>}
   */
  
  async renderArticleContent(index) {
    const id = this.getPagination(index);
    this.articleContainer.innerHTML = '';
    let content = await this.getArticleContent(id);
    this.articleContainer.append(content);
  }
  
  
  /**
   * 筛选分页的id
   * @param index
   * @returns {*}
   */
  
  getPagination(index = 1) {
    const selectId = this.articleContentsIds.find(article => {
      return article.page === index ? article : '';
    });
    return selectId.id;
  }
  
  
  /**
   * 获取分页的信息
   */
  
  getArticleInfo() {
    this.articleContents.forEach(article => this.articleContentsIds.push({
      id: article.dataset.articleId,
      page: article.dataset.paginationId.split('_')[1] - 0,
      title: article.querySelector('[data-title]')?.innerHTML
    }));
    
  }
  
  
  async getArticleContent(id) {
    const url = `/?section_id=${id}`;
    return await fetch(url).then((responseJson) => responseJson.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      return html.querySelector('[data-pagination]');
    });
  }
  
}


const articleContent = new ArticleContent();

/**
 
 * 定义分页组件
 
 */

class paginationNav extends HTMLElement {
  constructor() {
    super();
    this.articleContentsIds = articleContent.articleContentsIds;
    this.querySelector('ul').innerHTML = this.renderNav();
    this.querySelectorAll('li').forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.querySelectorAll('li').forEach(el => el.classList.remove('uk-active'));
        const {index} = event.target.dataset;
        articleContent.renderArticleContent(index - 0);
        element.classList.add('uk-active');
        currentPage = index - 0;
      })
    })
  }
  
  renderNav() {
    let navList = '';
    this.articleContentsIds.forEach(article => {
      navList += `<li class="${article.page - 0 === 1 ? 'uk-active' : ''}"><a class="uk-border-rounded" href="#js-article-title" data-index="${article.page}" data-id="${article.id}" uk-scroll="offset: 70;">${article.page}</a></li>`
    });
    return navList;
  }
}

customElements.define('pagination-nav', paginationNav);


/**
 
 * 定义目录
 
 */

class directoryNav extends HTMLElement {
  constructor() {
    super();
    this.directorys = [];
    articleContent.articleContents.forEach(article => {
      const titles = article.querySelectorAll('h2')?.length;
      if (titles > 0) {
        article.querySelectorAll('h2').forEach(title => {
          this.directorys.push({
            title: title?.innerHTML,
            index: title?.getAttribute('id'),
            page: article.dataset.paginationId.split('_')[1] - 0,
            id: article.dataset.articleId
          })
        })
      } else {
        this.directorys.push({
          title: article.querySelector('h2')?.innerHTML,
          index: article.querySelector('h2')?.getAttribute('id'),
          page: article.dataset.paginationId.split('_')[1] - 0,
          id: article.dataset.articleId
        })
      }
    });
    
    this.articleContentsIds = articleContent.articleContentsIds;
    this.querySelector('ul').innerHTML = this.renderNav();
    this.querySelectorAll('a').forEach(element => {
      element.addEventListener('click', (event) => {
        // event.preventDefault();
        const {page, id} = event.target.dataset;
        const index = event.target.getAttribute('href');
        this.changeClass(index);
        if (parseInt(page) !== currentPage) {
          currentPage = parseInt(page);
          articleContent.renderArticleContent(page - 0);
        }
      })
    })
  }
  
  changeClass(id) {
    this.querySelectorAll('li').forEach(el => el.closest('li').classList.remove('uk-active'));
    this.querySelector(`[href="${id}"]`).closest('li').classList.add('uk-active');
  }
  
  renderNav() {
    let navList = '';
    this.directorys.forEach((article, index) => {
      if (article.title) {
        navList += `<li><a href="#${article.index}" data-page="${article.page}" data-id="${article.id}" uk-scroll="offset: 80;">${article.title}</a></li>`
      }
    });
    return navList;
  }
}

customElements.define('directory-nav', directoryNav);


document.addEventListener('shopify:block:select', function (event) {
  // const {type, id} = JSON.parse(event.target.dataset.shopifyEditorBlock);
  
  // setTimeout(function () {
    // UIkit.scroll('body').scrollTo(document.querySelector(`[data-editor-id="${id}"]`));
  
    UIkit.scroll('body').scrollTo(0);
    // window.scrollTo({top: event.target.offsetTop, behavior: "smooth"});
    // parentSlideshowComponent.slider.scrollTo({
    //   left: event.target.offsetLeft
    // });
  // }, 400);
  
  
  // const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  // if (!blockSelectedIsSlide) return;
  //
  // const parentSlideshowComponent = event.target.closest('slideshow-component');
  // parentSlideshowComponent.pause();
  //
  // setTimeout(function() {
  //   parentSlideshowComponent.slider.scrollTo({
  //     left: event.target.offsetLeft
  //   });
  // }, 200);
});

// document.addEventListener('shopify:block:deselect', function (event) {
  
  // const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  // if (!blockDeselectedIsSlide) return;
  // const parentSlideshowComponent = event.target.closest('slideshow-component');
  // if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
// });
